import React, { useEffect, useRef, useState } from "react";
import style from "./Style.module.css";
import Nav from "../../Components/Nav";
import { Container } from "react-grid-system";
import file from "../../asset/videoPlayerIcon/file.png";
import durationIcon from "../../asset/videoPlayerIcon/duration.png";
import viewer from "../../asset/videoPlayerIcon/viewer.png";
import heart from "../../asset/videoPlayerIcon/heart.svg";
import chatGPT from "../../asset/videoPlayerIcon/chatGPT.svg";
import author from "../../asset/videoPlayerIcon/author.png";
import Grade from "../../asset/videoPlayer/Grade.png";
import Post_it from "../../asset/videoPlayer/post-it.png";
import Notebook from "../../asset/videoPlayer/Notebook.png";
import Pen from "../../asset/videoPlayer/pen.png";
import TailPen from "../../asset/videoPlayer/tail-pen.png";
import Hls from "hls.js";
import { useParams } from "react-router-dom";
import Util from "../../Util";

const Index = () => {
  const type = [
    "ทั้งเทอม",
    "มิดเทอม",
    "ไฟนอล",
    "สอบในห้อง",
    "อ่านเข้ามหาวิทยาลัย",
    "อ่านเข้า ม.4",
  ];
  const VIDEO_STORAGE_PREFIX = "video-timestamp-";
  const MAX_STORED_VIDEOS = 50;
  const videoRef = useRef(null);
  const [m3u8Url, setM3u8Url] = React.useState();
  const [sheet, setSheet] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [duration, setDuration] = useState();
  const [counted, setCounted] = useState(false);
  const [savedTime, setSavedTime] = useState(0);
  const { sheetId } = useParams();

  const formatDuration = (totalSeconds) => {
    const seconds = Math.floor(totalSeconds);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts = [];
    if (hours > 0) parts.push(`${hours} ชั่วโมง`);
    if (minutes > 0) parts.push(`${minutes} นาที`);
    if (secs > 0 || (parts.length === 0 && !isNaN(secs)))
      parts.push(`${secs} วินาที`);

    const timeStr = parts.join(" ");
    return timeStr.trim() === "" ? "-" : timeStr;
  };

  const loadSavedTime = () => {
    const saved = localStorage.getItem(`${VIDEO_STORAGE_PREFIX}${sheetId}`);
    if (saved) {
      try {
        const data = JSON.parse(saved);
        return data.timestamp;
      } catch (e) {
        return 0;
      }
    }
    return 0;
  };

  useEffect(() => {
    getM3u8Url();
    const savedTime = loadSavedTime();
    if (savedTime > 0) {
      setSavedTime(savedTime);
    }
  }, [sheetId]);

  useEffect(() => {
    try {
      if (videoRef.current && m3u8Url) {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(m3u8Url);
          hls.attachMedia(videoRef.current);
          setLoading(false);
        } else if (
          videoRef.current.canPlayType("application/vnd.apple.mpegurl")
        ) {
          videoRef.current.src = m3u8Url;
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("Error loading HLS video:", error);
    }
  }, [m3u8Url]);

  const getM3u8Url = async () => {
    try {
      const res = await Util.sendPost("/api/user/getReplayLiveStream", {
        id: sheetId,
      });
      setSheet(res.data);

      setM3u8Url(res.data.onlineTutor.liveReplayUrl);
    } finally {
      setLoading(false);
    }
  };

  const updateView = async () => {
    if (!counted) {
      Util.sendPost("/api/public/updateViews", {
        id: sheetId,
      });
      setCounted(true);
    }
  };

  const formatThaiDateTimeRange = (unixStart) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];

    const startDate = new Date(unixStart * 1000);
    const endDate = new Date((unixStart + duration) * 1000);

    const day = startDate.getDate();
    const month = monthsThai[startDate.getMonth()];
    const yearBE = startDate.getFullYear() + 543;

    const startTime = startDate.toLocaleTimeString("th-TH", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const endTime = endDate.toLocaleTimeString("th-TH", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    return `${day} ${month} ${yearBE} | ${startTime} - ${endTime} น.`;
  };

  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (!video) return;

    setDuration(video.duration);
  };

  const cleanupOldVideos = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith(VIDEO_STORAGE_PREFIX)
    );

    if (keys.length > MAX_STORED_VIDEOS) {
      // Remove oldest entries
      keys
        .sort((a, b) => {
          const timeA = localStorage.getItem(a).lastAccessed || 0;
          const timeB = localStorage.getItem(b).lastAccessed || 0;
          return timeA - timeB;
        })
        .slice(0, keys.length - MAX_STORED_VIDEOS)
        .forEach((key) => localStorage.removeItem(key));
    }
  };

  const saveVideoTime = () => {
    if (videoRef.current) {
      const data = JSON.stringify({
        timestamp: videoRef.current.currentTime,
        lastAccessed: Date.now(),
      });
      localStorage.setItem(`${VIDEO_STORAGE_PREFIX}${sheetId}`, data);
      cleanupOldVideos();
    }
  };

  return (
    <React.Fragment>
      <Nav current="video-player" />
      <div className={style.videoPlayerPage}>
        <img src={Pen} alt="pen" className={style.pen} />
        <img src={TailPen} alt="tailpen" className={style.tailPen} />
        <img src={Notebook} alt="notebook" className={style.Notebook} />
        <Container>
          <div className={style.blanker} />
          <img src={Grade} alt="grade" className={style.gradeImg} />

          <img src={Grade} alt="grade" className={style.gradeImg} />
          <img src={Post_it} alt="post-it" className={style.postItImg} />

          <div className={style.contentContainer}>
            <div
              className={style.ciStoreContainer}
              style={{
                background:
                  "linear-gradient(90deg,#FEE58099 0%, #B2BB1F99 70%)",
              }}
            >
              <div className={style.videoContainer}>
                {loading ? <div key="loader" className={style.loader} /> : null}
                <video
                  ref={videoRef}
                  controls
                  muted
                  className={style.videoPlayer}
                  onLoadedMetadata={handleLoadedMetadata}
                  onPlay={() => updateView()}
                  onTimeUpdate={() => saveVideoTime()}
                  onLoadedData={() => {
                    if (savedTime > 0) {
                      videoRef.current.currentTime = savedTime;
                    }
                  }}
                />
              </div>
              <div className={style.dateTagLabel}>
                คลิปย้อนหลัง{" "}
                {sheet?.onlineTutor?.startDate && duration
                  ? formatThaiDateTimeRange(sheet?.onlineTutor?.startDate)
                  : "-"}
              </div>
            </div>
            <div className={style.metaContainer}>
              <div
                className={style.flexRowBetween}
                style={{ marginBottom: 16 }}
              >
                <div className={style.titleVideo}>{sheet?.name ?? "-"}</div>
                {/* <p className={style.likeText}>
                  <img src={heart} alt="heart" className={style.heart} /> 241
                </p> */}
              </div>

              <div className={style.flexRowBetween}>
                <div className={style.metaDataGroup}>
                  <div className={style.dataGroup}>
                    <img src={file} alt="file" />{" "}
                    <p>
                      {sheet?.category !== undefined
                        ? type[sheet?.category] + " | "
                        : "-"}
                      {sheet?.semester !== undefined &&
                      sheet?.year !== undefined ? (
                        <>
                          {sheet?.semester}/{sheet?.year}
                        </>
                      ) : null}
                    </p>
                  </div>
                  <div className={style.dataGroup}>
                    <img src={durationIcon} alt="duration" />{" "}
                    <p>{formatDuration(duration) ?? "-"}</p>
                  </div>

                  <div className={style.dataGroup}>
                    {" "}
                    <img src={viewer} alt="viewer" />{" "}
                    <p>{sheet?.onlineTutor?.views ?? 0} คน</p>
                  </div>
                </div>
                <p className={style.likeText}>
                  <img src={author} alt="author" />
                  {sheet?.author ?? "-"}
                </p>
              </div>

              {/* <div className={style.greyContainer}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "40px 1fr",
                    gap: "8px",
                    marginTop: "4px",
                  }}
                >
                  <img
                    src={chatGPT}
                    alt="chatGPT"
                    style={{ marginTop: "4px" }}
                  />
                  <div>
                    <span className={style.aiLabel}>
                      คำอธิบายรายละเอียดการติว โดย AI
                    </span>
                    <p>
                      การนำแนวคิดทางการตลาดมาประยุกต์ใช้เพื่อสร้างความต้องการและดึงดูดนักท่องเที่ยว โดยเน้นที่การวิจัยความต้องการของนักท่องเที่ยว,
                      การคาดการณ์แนวโน้มตลาด,
                      และการสร้างสรรค์บริการและผลิตภัณฑ์ท่องเที่ยวที่ตอบโจทย์ เพื่อเพิ่มส่วนแบ่งการตลาด,
                      สร้างความพึงพอใจและรักษาลูกค้าประจำ
                      การนำแนวคิดทางการตลาดมาประยุกต์ใช้เพื่อสร้างความต้องการและดึงดูดนักท่องเที่ยว โดยเน้นที่การวิจัยความต้องการของนักท่องเที่ยว,
                      การคาดการณ์แนวโน้มตลาด,
                      และการสร้างสรรค์บริการและผลิตภัณฑ์ท่องเที่ยวที่ตอบโจทย์ เพื่อเพิ่มส่วนแบ่งการตลาด,
                      สร้างความพึงพอใจและรักษาลูกค้าประจำ
                      การนำแนวคิดทางการตลาดมาประยุกต์ใช้เพื่อสร้างความต้องการและดึงดูดนักท่องเที่ยว โดยเน้นที่การวิจัยความต้องการของนักท่องเที่ยว,
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Index;
